'use strict';

angular.module('shiftTraderApp')
  .controller('PickupsCtrl', function ($scope, trades, me) {
    $scope.me = me;
    $scope.allAvailablePickups = _.invoke(trades, '$initialize');
    $scope.allAvailablePickups = _.filter($scope.allAvailablePickups, function(t) {
      return t.$isGiveaway() && t.user.id !== me.id &&
        !_.any(t.shift_trade_responses, function(resp) {
          return _.include([10, 20, 21],resp.acceptance_code);
        }) && t.$calculateActive(true) &&
        t.work_period.$isQualifiedForPickup($scope.me);
    });
  });
